import React, { Component } from 'react';
import { translate } from 'react-i18next';
import ReactGA from 'react-ga';
import { Cross } from '../icons';

class FilterResults extends Component {
  constructor(props) {
    super(props);
    this.selectAll();
  }
  state = {};
  filteredApplications = [];
  results = [];
  applications = this.props.applications;

  componentDidUpdate(prevProps, prevState) {
    let checkedElements = [];

    for (var element of document.querySelectorAll('.selects input')) {
      if (element.checked) checkedElements.push(element);
    }

    if (this.state.showContent !== prevState.showContent && checkedElements.length === 0) {
      this.selectAll();
    }
  }

  handleChange = (e) => {
    if (e.target.checked) {
      this.filteredApplications.push(e.target.value);
    } else {
      const index = this.filteredApplications.indexOf(e.target.value);
      this.filteredApplications.splice(index, 1);
    }
  };

  selectAll = () => {
    this.filteredApplications = [];

    for (var element of document.querySelectorAll('.selects input')) {
      element.checked = true;
    }

    for (var application of this.applications) {
      this.filteredApplications.push(application.applications[0].id);
    }
  };

  deSelectAll = () => {
    this.filteredApplications = [];

    for (var element of document.querySelectorAll('.selects input')) {
      element.checked = false;
    }
  };

  updateResults = () => {
    this.results = [];

    for (var element of this.applications) {
      if (this.filteredApplications.includes(element.applications[0].id)) {
        this.results.push(element);
      }
    }

    this.props.updateResults(this.results);
    this.setState({ showContent: false });
  };

  render() {
    const { t, selectedFamily } = this.props;

    const content = (
      <div className={this.state.showContent ? 'content' : 'content hidden'}>
        <div className="select-content">
          {t('filter_results.select_applications')}
          <div className="group-select">
            <p
              onClick={() => {
                this.selectAll();
                ReactGA.event({
                  category: selectedFamily,
                  action: 'Results',
                  label: 'Filter Reset',
                });
              }}
            >
              {t('filter_results.select_all')}
            </p>
            <span>|</span>
            <p onClick={this.deSelectAll}>{t('filter_results.deselect_all')}</p>
          </div>
          <div className="selects">
            {this.applications.map((application) => {
              return (
                <label className="select" key={application.applications[0].id}>
                  <input
                    type="checkbox"
                    value={application.applications[0].id}
                    onChange={this.handleChange}
                  />
                  <span>{application.name}</span>
                </label>
              );
            }, this)}
          </div>
        </div>
        <div className="button-container">
          <a className="close" onClick={() => this.setState({ showContent: false })}>
            <Cross size="10px" /> {t('filter_results.close')}
          </a>
          <a
            onClick={() => {
              this.updateResults();
              ReactGA.event({
                category: this.props.i18n.language,
                action: selectedFamily,
                label: 'Filter Update',
              });
            }}
            className="button"
          >
            {t('filter_results.update_results')}
          </a>
        </div>
      </div>
    );

    return (
      <section className="filters">
        <div
          onClick={() => this.setState({ showContent: !this.state.showContent })}
          className={this.state.showContent ? 'tab-name active' : 'tab-name'}
        >
          {t('filter_results.filter_applications')}
        </div>
        {content}
      </section>
    );
  }
}

export default translate('translations')(FilterResults);



// WEBPACK FOOTER //
// ./src/components/results/filterResults.js